import { combineReducers } from "redux";

import {
  calls,
  call,
  savingCall,
  callToSave,
  callToDelete,
  callsToApprove,
  partToDelete,
  recurringCalls,
  recurrence,
  range,
  callCount,
  callApprovalToNotify
} from "./callReducer";
import {
  supportTicket,
  supportTickets,
  savingSupportTicket,
  supportTicketsBoard
} from "./supportTicketReducer";
import {
  contracts,
  contract,
  loadingContract,
  savingContract,
  contractToDelete,
  contractPOToDelete,
  contractNoteToDelete,
  contractsByCustomer,
  itmsContracts
} from "./contractReducer";
import {
  chargetypes,
  chargetype,
  savingChargetype,
  chargetypeToDelete
} from "./chargetypeReducer";
import { codes, code, savingCode, codeToDelete } from "./codeReducer";
import {
  services,
  service,
  savingService,
  serviceToDelete
} from "./serviceReducer";
import { roles, role, savingRole, roleToDelete } from "./roleReducer";
import { departments, department } from "./departmentReducer";
import { labels, label, savingLabel, labelToDelete } from "./labelReducer";
import {
  customers,
  customer,
  savingCustomer,
  customerToDelete,
  customerLocationToDelete,
  customerContactToDelete,
  customerNoteToDelete,
  inProgressCustomerProjects
} from "./customerReducer";
import {
  allUsers,
  users,
  user,
  savingUser,
  userToDelete,
  auth,
  resource_summary
} from "./userReducer";
import { file } from "./fileReducer";
import {
  projects,
  project,
  savingProject,
  projectToDelete,
  projectTaskToDelete,
  projectNoteToDelete,
  projectAttachmentToDelete,
  projectNotificationToDelete,
  paginatedProjects,
  withSupportResourcesProjects
} from "./projectReducer";
import { modal } from "./modalReducer";
import { alert } from "./alertReducer";
import {
  expense,
  expenses,
  savingExpense,
  expenseToDelete,
  expenseReceiptToDelete
} from "./expenseReducer";
// import { router } from "./routerReducer";
import { budgets } from "./budgetReducer";
import {
  ptoRequest,
  ptoRequests,
  savingPtoRequest,
  ptoRequestToDelete,
  ptoRequestReceiptToDelete,
  ptoBalance
} from "./ptoRequestReducer";
import { loading } from "./loaderReducer";
import {
  contractTiers,
  contractTier,
  savingContractTier
} from "./contractTierReducer";
import { tasks, task, savingTask } from "./taskReducer";
import {
  report,
  DPSReport,
  resource_summary_report,
  PESReport,
  DCCReport,
  OSTReport,
  PSAReport
} from "./reportReducer";
import {
  departmentCategory,
  departmentCategories
} from "./departmentCategoryReducer";
import { exporting, exported } from "./exportReducer";
import { taxCodes } from "./taxCodeReducer";

const rootReducer = combineReducers({
  budgets,
  modal,
  alert,
  // router,
  users,
  user,
  savingUser,
  userToDelete,
  auth,
  customers,
  customer,
  savingCustomer,
  customerToDelete,
  customerLocationToDelete,
  customerContactToDelete,
  customerNoteToDelete,
  labels,
  label,
  savingLabel,
  labelToDelete,
  departments,
  department,
  roles,
  role,
  savingRole,
  roleToDelete,
  projects,
  project,
  savingProject,
  projectToDelete,
  projectTaskToDelete,
  projectNoteToDelete,
  projectAttachmentToDelete,
  projectNotificationToDelete,
  services,
  service,
  savingService,
  serviceToDelete,
  codes,
  code,
  savingCode,
  codeToDelete,
  chargetypes,
  chargetype,
  savingChargetype,
  chargetypeToDelete,
  contracts,
  contract,
  loadingContract,
  savingContract,
  contractToDelete,
  contractPOToDelete,
  contractNoteToDelete,
  calls,
  call,
  savingCall,
  callsToApprove,
  callToSave,
  callToDelete,
  partToDelete,
  recurringCalls,
  recurrence,
  range,
  callCount,
  supportTicket,
  supportTickets,
  savingSupportTicket,
  supportTicketsBoard,
  file,
  expense,
  expenses,
  expenseToDelete,
  savingExpense,
  expenseReceiptToDelete,
  allUsers,
  ptoRequest,
  ptoRequests,
  ptoRequestToDelete,
  savingPtoRequest,
  contractsByCustomer,
  ptoRequestReceiptToDelete,
  loading,
  contractTiers,
  contractTier,
  savingContractTier,
  tasks,
  task,
  savingTask,
  report,
  ptoBalance,
  departmentCategory,
  departmentCategories,
  paginatedProjects,
  resource_summary,
  DPSReport,
  exporting,
  exported,
  resource_summary_report,
  itmsContracts,
  PESReport,
  callApprovalToNotify,
  DCCReport,
  OSTReport,
  PSAReport,
  inProgressCustomerProjects,
  withSupportResourcesProjects,
  taxCodes
});
export default rootReducer;
